export default __webpack_public_path__ + "static/media/l-6.c5e352f1.jpg";